export default __webpack_public_path__ + "6629b7a8f7992ac2794a6054d5725043.png";